// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';
import './index.css';
import './core/i18n';
import Providers from './providers/index.tsx';

import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !import.meta.env.DEV,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_STAGE as string,
});

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Providers />,
  // </StrictMode>
);
